/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Message from "../../utils/Message";
import { getCacheData } from "../../services/CacheService";
import {
  getIngresoCristal,
  getIngresoCristalListaPrecio,
  saveIngresoCristal
} from "../../services/IngresoCristalService";
import IngresoCristalDinamicTable from "./IngresoCristalDinamicTable";
import WaitingDialog from "../../utils/WaitingDialog";
import { formatMoney } from "../../utils/utils";

const initialState = {
  codigoIngreso: "",
  idAreaIngreso: "",
  idProveedor: "",
  fechaRegistracion: format(new Date(), "dd/MM/yyyy"),
  idCristalProducto: "",
  idBlCrDiametro: "",
  idBlCrAdicion: "",
  idOjo: "",
  observaciones: "",
  valorDolarActual: "",
};

const ojoOptions = [
  {
    id: "izquierdo",
    label: "IZQUIERDO",
  },
  {
    id: "derecho",
    label: "DERECHO",
  },
  {
    id: "indistinto",
    label: "INDISTINTO",
  },
];

const nameItemsText = "Ingreso de cristales";
//
// ###########################################################################
//
const IngresoCristal = () => {
  const params = useParams();
  const _idIngresoCristal = params.idIngresoCristal;
  const _action = params.action;
  const navigate = useNavigate();
  const [ingresoCristalData, setIngresoCristalData] = useState(initialState);
  const [ingresoCristalList, setIngresoCristalList] = useState([]);
  const [actionTitle, setActionTitle] = useState("");

  const [areas, setAreas] = useState([]);
  const [valueACAreaIngreso, setValueACAreaIngreso] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACAreaIngreso, setInputValueACAreaIngreso] = useState("");

  const [proveedores, setProveedores] = useState([]);
  const [valueACProveedor, setValueACProveedor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");

  const [cristalProductos, setCristalProductos] = useState([]);
  const [valueACCristalProducto, setValueACCristalProducto] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACCristalProducto, setInputValueACCristalProducto] =
    useState("");

  const [blCrDiametros, setBlCrDiametros] = useState([]);
  const [valueACBlCrDiametro, setValueACBlCrDiametro] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrDiametro, setInputValueACBlCrDiametro] = useState("");

  const [blCrAdiciones, setBlCrAdiciones] = useState([]);
  const [valueACBlCrAdicion, setValueACBlCrAdicion] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrAdicion, setInputValueACBlCrAdicion] = useState("");

  const [valueACOjo, setValueACOjo] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACOjo, setInputValueACOjo] = useState("");

  const [anulado, setAnulado] = useState(false);
  const [motivoAnulacion, setMotivoAnulacion] = useState("");

  const [showTableEsfCil, setShowTableEsfCil] = useState(false);

  const [cilMax, setCilMax] = useState(0);
  const [cilMin, setCilMin] = useState(0);
  const [esfMax, setEsfMax] = useState(0);
  const [esfMin, setEsfMin] = useState(0);

  const [correccionesSinPrecioList, setCorreccionesSinPrecioList] = useState(
    [],
  );
  const [loading, setLoading] = useState(false);
  const [disabledHeaderFields, setDisabledHeaderFields] = useState(false);
  const [rangosList, setRangosList] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [recharge, setRecharge] = useState(false);
  const [disabledSearchLPCristal, setDisabledSearchLPCristal] = useState(true);

  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);

  const tableColumns = [
    {
      field: "esfera_desde",
      headerName: "Esfera Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_desde);
      },
    },
    {
      field: "esfera_hasta",
      headerName: "Esfera Hasta",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_hasta);
      },
    },
    {
      field: "cilindro_desde",
      headerName: "Cilindro Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_desde);
      },
    },
    {
      field: "cilindro_hasta",
      headerName: "Cilindro Hasta",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_hasta);
      },
    },
    {
      field: "costo_pesos",
      headerName: "Costo $",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.costo_pesos);
      },
    },
    {
      field: "valor_dolar",
      headerName: "Valor u$s",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.valor_dolar);
      },
    },
    {
      field: "porcentaje_descuento",
      headerName: "% Descuento",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.porcentaje_descuento);
      },
    },
    {
      field: "costo_real",
      headerName: "Costo Real",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.costo_real);
      },
    },
    {
      field: "tiempo_entrega",
      headerName: "T. de Entrega (días)",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
  ];
  //
  // ##########################################################################
  //
  useEffect(() => {
    if (_action === "view") {
      setActionTitle("Ver");
    } else if (_action === "update") {
      setActionTitle("Editando");
    } else if (_action === "new") {
      setActionTitle("Nuevo");
    } else if (_action === "delete") {
      setActionTitle("Anular");
    }

    loadAreas();
    loadProveedores();
    loadCristalProductos();
    loadBlCrDiametros();
    loadBlCrAdiciones();
    setDisabledSearchLPCristal(true);

    if (_action !== "new") {
      load();
    }
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    let _disabled = true;
    if (
      valueACProveedor.id &&
      valueACCristalProducto.id &&
      valueACBlCrDiametro.id &&
      valueACBlCrAdicion.id
    ) {
      _disabled = false;
    }
    setDisabledSearchLPCristal(_disabled);
  }, [valueACProveedor, valueACCristalProducto, valueACBlCrDiametro, valueACBlCrAdicion]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (recharge) {
      loadListaPrecioData();
    }
  }, [recharge]);
  //
  // ##########################################################################
  //
  const handleLimpiar = () => {
    setIngresoCristalData(initialState);
    setValueACProveedor({ descripcion: "", id: "" });
    setInputValueACProveedor("");
    setValueACCristalProducto({ descripcion: "", id: "" });
    setInputValueACCristalProducto("");
    setValueACBlCrDiametro({ descripcion: "", id: "" });
    setInputValueACBlCrDiametro("");
    setValueACBlCrAdicion({ descripcion: "", id: "" });
    setInputValueACBlCrAdicion("");
    setValueACOjo({ label: "", id: "" });
    setInputValueACOjo("");
    setDisabledSearchLPCristal(true);

    setLoading(false);
    setShowTableEsfCil(false);
    setDisabledHeaderFields(false);
    setTabIndex(0);
    setIngresoCristalList([]);
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/ingreso-cristal-table");
  };

  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setIngresoCristalData({
      ...ingresoCristalData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === "motivoAnulacion") {
      setMotivoAnulacion(e.target.value);
    }
  };
  //
  // ##########################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getIngresoCristal(_idIngresoCristal);
    setIsDoingSomething(false);

    if (response.ok) {

      const _ingresoArticuloData = response.data.data;
      const _valorDolarActual = _ingresoArticuloData.valor_dolar_actual;
      const _ingresoArticuloList = _ingresoArticuloData.ingreso_articulo_list;
      const _ingresoEstadoList = _ingresoArticuloData.ingreso_estado_list;

      setIngresoCristalData({
        ...ingresoCristalData,
        codigoIngreso: _ingresoArticuloData.codigo,
        fechaRegistracion: _ingresoArticuloData.fecha_creacion,
        observaciones: _ingresoArticuloData.observaciones,
        valorDolarActual: _valorDolarActual,
      });

      setValueACAreaIngreso({
        id: _ingresoArticuloData.id_area,
        label: _ingresoArticuloData.descripcion_area,
      });
      setInputValueACAreaIngreso(_ingresoArticuloData.descripcion_area);

      setValueACProveedor({
        id: _ingresoArticuloData.id_proveedor,
        label:
          _ingresoArticuloData.descripcion_proveedor +
          (_ingresoArticuloData.contacto_proveedor
            ? " - " + _ingresoArticuloData.contacto_proveedor
            : ""),
      });
      setInputValueACProveedor(
        _ingresoArticuloData.descripcion_proveedor +
        (_ingresoArticuloData.contacto_proveedor
          ? " - " + _ingresoArticuloData.contacto_proveedor
          : ""),
      );

      setValueACCristalProducto({
        id: _ingresoArticuloData.id_cristal_producto,
        label: _ingresoArticuloData.descripcion_cristal_producto,
      });
      setInputValueACCristalProducto(_ingresoArticuloData.descripcion_cristal_producto);

      setValueACBlCrDiametro({
        id: _ingresoArticuloData.id_bl_cr_diametro,
        valor: _ingresoArticuloData.valor_bl_cr_diametro,
      });
      setInputValueACBlCrDiametro(_ingresoArticuloData.valor_bl_cr_diametro);

      setValueACBlCrAdicion({
        id: _ingresoArticuloData.id_bl_cr_adicion,
        valor: _ingresoArticuloData.valor_bl_cr_adicion,
      });
      setInputValueACBlCrAdicion(_ingresoArticuloData.valor_bl_cr_adicion);

      setValueACOjo({
        id: _ingresoArticuloData.ojo,
        label: _ingresoArticuloData.ojo ? _ingresoArticuloData.ojo.toUpperCase() : "",
      });

      setIngresoCristalList(_ingresoArticuloList);

      let _motivoAnulacion = "";
      _ingresoEstadoList.forEach((item) => {
        if (item.estado !== "activo") {
          _motivoAnulacion = item.motivo_anulacion;
          setAnulado(true);
        }
        setMotivoAnulacion(_motivoAnulacion.toUpperCase());
      });

      setRecharge(true);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData("area");
    if (response.ok) {
      const _response = response.data.data.filter(
        (area) =>
          area.interno_externo === "interno" &&
          area.actividad === "produccion" &&
          area.produccion_ingresa_articulos,
      );
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setAreas(_var);
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label:
            item.descripcion + (item.contacto ? " - " + item.contacto : ""),
        });
      });
      setProveedores(_var);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCristalProductos = async () => {
    const response = await getCacheData("cristal_producto");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCristalProductos(_var);
    } else {
      setCristalProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrDiametros = async () => {
    const response = await getCacheData("bl_cr_diametro");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          valor: item.valor,
        });
      });
      setBlCrDiametros(_var);
    } else {
      setBlCrDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrAdiciones = async () => {
    const response = await getCacheData("bl_cr_adicion");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          valor: item.valor,
        });
      });
      setBlCrAdiciones(_var);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadListaPrecioData = async () => {

    setShowTableEsfCil(false);

    let _params = {
      id_proveedor: valueACProveedor.id,
      id_cristal_producto: valueACCristalProducto.id,
      id_bl_cr_diametro: valueACBlCrDiametro.id,
      id_bl_cr_adicion: valueACBlCrAdicion.id,
    };

    setIsDoingSomething(true);
    const response = await getIngresoCristalListaPrecio(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      let _rangosList = _response.rangos_list;

      setRangosList(_rangosList);
      setEsfMax(_response.esfera_max);
      setEsfMin(_response.esfera_min);
      setCilMax(_response.cilindro_max);
      setCilMin(_response.cilindro_min);
      setCorreccionesSinPrecioList(_response.correcciones_sin_precio_list);

      setShowTableEsfCil(true);
      setDisabledHeaderFields(true);
    } else {

      setShowTableEsfCil(false);
      setLoading(false);
      setDisabledHeaderFields(false);

      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  //
  // ##########################################################################
  //
  const handleSave = async () => {

    if (_action === "new" || _action === "update") {
      if (valueACAreaIngreso.id === "" || valueACAreaIngreso.id === null) {
        setMessage({
          messageText: "Debes seleccionar un Area de ingreso",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (valueACProveedor.id === "" || valueACProveedor.id === null) {
        setMessage({
          messageText: "Debes seleccionar un Proveedor",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (
        valueACCristalProducto.id === "" ||
        valueACCristalProducto.id === null
      ) {
        setMessage({
          messageText: "Debes seleccionar un Producto",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (valueACBlCrDiametro.id === "" || valueACBlCrDiametro.id === null) {
        setMessage({
          messageText: "Debes seleccionar un Diámetro",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (valueACBlCrAdicion.id === "" || valueACBlCrAdicion.id === null) {
        setMessage({
          messageText: "Debes seleccionar una Adición",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (valueACOjo.id === "" || valueACOjo.id === null) {
        setMessage({
          messageText: "Debes seleccionar Ojo",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    } else {
      if (motivoAnulacion === "") {
        setMessage({
          messageText: "Debes ingresar el Motivo de Anulación",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }

    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {

    let _ingresoCristalObject = {};
    if (_action === "new" || _action === "update") {

      _ingresoCristalObject = {
        id_area: valueACAreaIngreso.id,
        id_proveedor: valueACProveedor.id,
        id_cristal_producto: valueACCristalProducto.id,
        id_bl_cr_diametro: valueACBlCrDiametro.id,
        id_bl_cr_adicion: valueACBlCrAdicion.id,
        ojo: valueACOjo.id,
        observaciones: ingresoCristalData.observaciones.toUpperCase(),
        ingreso_articulo_list: ingresoCristalList,
        esfera_min: esfMin,
        esfera_max: esfMax,
        cilindro_min: cilMin,
        cilindro_max: cilMax,
        rangos_list: rangosList,
        correcciones_sin_precio_list: correccionesSinPrecioList,
        cambia_producto: false,
      };
      if (_action !== "new") {
        _ingresoCristalObject.id = _idIngresoCristal;
      }
    } else {
      _ingresoCristalObject = {
        id: _idIngresoCristal,
        motivo_anulacion: motivoAnulacion,
      };
    }

    setIsDoingSomething(true);
    const response = await saveIngresoCristal(_action, _ingresoCristalObject);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        navigate("/ingreso-cristal-table");
      }, 500);
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper
        elevation={1}
        sx={{
          borderStyle: "solid",
          borderColor: "#e0e0e0",
          borderWidth: 1,
          p: 1,
          m: 1,
          maxWidth: "100%",
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ m: 1, mb: 3 }}
            >
              <Typography variant="h5" display="block" gutterBottom>
                {actionTitle} {nameItemsText} {ingresoCristalData.codigoIngreso}
              </Typography>
            </Box>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }}>
            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                size="small"
                value={valueACAreaIngreso}
                onChange={(event, newValue) => {
                  setValueACAreaIngreso(newValue);
                }}
                inputValue={inputValueACAreaIngreso}
                onInputChange={(event, newInputValue) => {
                  setInputValueACAreaIngreso(newInputValue);
                }}
                id="AreaIngreso"
                options={areas}
                renderInput={(params) => (
                  <TextField {...params} label="Area de Ingreso" />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
                disabled={_action === "view" || _action === "delete" || disabledHeaderFields}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                size="small"
                value={valueACProveedor}
                onChange={(event, newValue) => {
                  setValueACProveedor(newValue);
                }}
                inputValue={inputValueACProveedor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACProveedor(newInputValue);
                }}
                id="Proveedor"
                options={proveedores}
                renderInput={(params) => (
                  <TextField {...params} label="Proveedor" />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
                disabled={
                  _action === "view" ||
                  _action === "delete" ||
                  disabledHeaderFields
                }
              />
            </Grid>

            <Grid item xs={12} md={12} lg={2}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                }}
                id="fechaRegistracion"
                label="Fecha de Registración"
                variant="outlined"
                size="small"
                name="fechaRegistracion"
                value={initialState.fechaRegistracion}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={6}>
              <Autocomplete
                id="id-cristal-producto"
                size="small"
                value={
                  valueACCristalProducto && valueACCristalProducto.id
                    ? valueACCristalProducto
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACCristalProducto(newValue);
                  setIngresoCristalData({
                    ...ingresoCristalData,
                    idCristalProducto: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACCristalProducto}
                onInputChange={(event, newInputValue) => {
                  setInputValueACCristalProducto(newInputValue);
                }}
                options={cristalProductos}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField {...params} label="Producto" />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  _action === "view" ||
                  _action === "delete" ||
                  disabledHeaderFields
                }
              />
            </Grid>

            <Grid item xs={12} md={12} lg={1}>
              <Autocomplete
                id="id-bl-cr-diametro"
                size="small"
                value={
                  valueACBlCrDiametro && valueACBlCrDiametro.id
                    ? valueACBlCrDiametro
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrDiametro(newValue);
                  setIngresoCristalData({
                    ...ingresoCristalData,
                    idBlCrDiametro: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrDiametro}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrDiametro(newInputValue);
                }}
                options={blCrDiametros}
                getOptionLabel={(option) => option.valor.toString()}
                renderInput={(params) => (
                  <TextField {...params} label="Diámetro " />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  _action === "view" ||
                  _action === "delete" ||
                  disabledHeaderFields
                }
              />
            </Grid>

            <Grid item xs={12} md={12} lg={1}>
              <Autocomplete
                id="id-bl-cr-adicion"
                size="small"
                value={
                  valueACBlCrAdicion && valueACBlCrAdicion.id
                    ? valueACBlCrAdicion
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrAdicion(newValue);
                  setIngresoCristalData({
                    ...ingresoCristalData,
                    idBlCrAdicion: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrAdicion}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrAdicion(newInputValue);
                }}
                options={blCrAdiciones}
                getOptionLabel={(option) => option.valor.toFixed(2)}
                renderInput={(params) => (
                  <TextField {...params} label="Adición " />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  _action === "view" ||
                  _action === "delete" ||
                  disabledHeaderFields
                }
              />
            </Grid>

            <Grid item xs={12} md={12} lg={2}>
              <Autocomplete
                id="id-ojo"
                size="small"
                value={valueACOjo && valueACOjo.id ? valueACOjo : null}
                onChange={(event, newValue) => {
                  setValueACOjo(newValue);
                  setIngresoCristalData({
                    ...ingresoCristalData,
                    idOjo: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACOjo}
                onInputChange={(event, newInputValue) => {
                  setInputValueACOjo(newInputValue);
                }}
                options={ojoOptions}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione Ojo " />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  _action === "view" ||
                  _action === "delete" ||
                  disabledHeaderFields
                }
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={1}
            sx={{ ml: 1, mb: 1 }}
            justifyContent="flex-start"
          >
            <Grid item xs={12} md={12} lg={3}>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  fullWidth
                  variant="contained"
                  size="small"
                  onClick={loadListaPrecioData}
                  startIcon={<SearchIcon />}
                  disabled={
                    disabledSearchLPCristal ||
                    disabledHeaderFields ||
                    anulado === true
                  }
                >
                  Buscar Lista de Precios del Proveedor
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} md={12} lg={1}>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  onClick={handleLimpiar}
                  startIcon={<CleaningServicesIcon />}
                  disabled={_action === "view" || _action === "delete"}
                >
                  Limpiar
                </Button>
              </Box>
            </Grid>

            {showTableEsfCil && (
              <Grid item xs={12} sx={{ width: "100%" }}>
                <Paper
                  elevation={0}
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflow: "hidden",
                    boxSizing: "border-box",
                  }}
                >
                  <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                  >
                    <Tab label="Cristales" />
                    <Tab label="Rangos de Precios" />
                  </Tabs>

                  {tabIndex === 0 && (
                    <IngresoCristalDinamicTable
                      action={_action}
                      esfMax={esfMax}
                      esfMin={esfMin}
                      cilMax={cilMax}
                      cilMin={cilMin}
                      rangosList={rangosList}
                      correccionesSinPrecioList={correccionesSinPrecioList}
                      setIngresoCristalList={setIngresoCristalList}
                      ingresoCristalList={ingresoCristalList}
                    />
                  )}

                  {tabIndex === 1 && (
                    <Box sx={{ m: 2 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          marginBottom: "10px",
                          padding: "8px",
                          textAlign: "left",
                        }}
                      >
                        Rangos de Precios
                      </Typography>
                      <DataGrid
                        rows={rangosList}
                        columns={tableColumns}
                        getRowId={(row, index) =>
                          `rango-${index}-${row.esfera_desde}-${row.esfera_hasta}-${row.cilindro_desde}-${row.cilindro_hasta}`
                        }
                        rowHeight={40}
                        columnHeaderHeight={45}
                        disableColumnMenu
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        disableRowSelectionOnClick
                        hideFooter
                        localeText={{ noRowsLabel: "" }}
                      />
                    </Box>
                  )}
                </Paper>
              </Grid>
            )}
          </Grid>

          <Grid item xs={12}>
            <TextField
              inputProps={{
                autoComplete: "off",
              }}
              id="observaciones"
              label="Observaciones"
              variant="outlined"
              name="observaciones"
              value={ingresoCristalData.observaciones}
              onChange={handleChange}
              disabled={
                _action === "delete" ||
                _action === "enable" ||
                _action === "view"
              }
              multiline
              rows={3}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  minHeight: "80px",
                },
                mt: 1,
              }}
            />
          </Grid>

          {(anulado !== false || _action === "delete") && (
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                autoFocus
                sx={{ width: "100%", mb: 1, mt: 2 }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="motivoAnulacion"
                label="Motivo de Anulación"
                variant="outlined"
                size="small"
                name="motivoAnulacion"
                value={motivoAnulacion}
                onChange={handleChange}
                disabled={_action === "view"}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
            >
              {_action !== "view" && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={_action !== "delete" ? "primary" : "error"}
                  startIcon={
                    _action !== "delete" ? (
                      <SaveIcon />
                    ) : (
                      <RemoveCircleOutlineIcon />
                    )
                  }
                >
                  {_action !== "delete"
                    ? "Guardar"
                    : "Anular"}
                </Button>
              )}

              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelar}
              >
                {_action === "view"
                  ? "Cerrar"
                  : "Cancelar"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={loading || isDoingSomething} />
    </>
  );
};
export default IngresoCristal;
